/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import Icon from '../../Icon';
var IconLeft = /*#__PURE__*/React.createElement(Icon, {
  fontSize: 12,
  className: "jmti-angle-left"
});
var IconRight = /*#__PURE__*/React.createElement(Icon, {
  fontSize: 12,
  className: "jmti-angle-right"
});

var SimplePagination = function SimplePagination(_ref) {
  var className = _ref.className,
      size = _ref.size,
      totalPage = _ref.totalPage,
      currentPage = _ref.currentPage,
      _ref$operateDisabled = _ref.operateDisabled,
      prevDisabled = _ref$operateDisabled.prevDisabled,
      nextDisabled = _ref$operateDisabled.nextDisabled,
      onCurrentPage = _ref.onCurrentPage;
  return /*#__PURE__*/React.createElement("ul", {
    className: classNames('jmtd-pagination-simple', className, {
      'jmtd-pagination-simple-mini': size === 'mini',
      'jmtd-pagination-simple-small': size === 'small',
      'jmtd-pagination-simple-middle': ['mini', 'small', 'large'].indexOf(size) === -1,
      'jmtd-pagination-simple-large': size === 'large'
    })
  }, /*#__PURE__*/React.createElement("li", {
    className: classNames('jmtd-pagination-item', 'jmtd-pagination-item-prev', {
      'jmtd-pagination-item-disabled': prevDisabled
    }),
    onClick: function onClick() {
      return !prevDisabled && onCurrentPage(currentPage, 'prev');
    },
    "data-event-name": "paginate",
    "data-event-content": "\u524D"
  }, IconLeft), /*#__PURE__*/React.createElement("li", {
    className: "jmtd-pagination-item jmtd-pagination-item-current"
  }, currentPage), /*#__PURE__*/React.createElement("li", {
    className: "jmtd-pagination-item jmtd-pagination-item-separator"
  }, "/"), /*#__PURE__*/React.createElement("li", {
    className: "jmtd-pagination-item jmtd-pagination-item-total"
  }, totalPage), /*#__PURE__*/React.createElement("li", {
    "data-event-name": "paginate",
    "data-event-content": "\u540E",
    className: classNames('jmtd-pagination-item', 'jmtd-pagination-item-next', {
      'jmtd-pagination-item-disabled': nextDisabled
    }),
    onClick: function onClick() {
      return !nextDisabled && onCurrentPage(currentPage, 'next');
    }
  }, IconRight));
};

SimplePagination.propTypes = {
  className: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['mini', 'small', 'middle', 'large']).isRequired,
  totalPage: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  operateDisabled: PropTypes.object.isRequired,
  onCurrentPage: PropTypes.func.isRequired
};
export default SimplePagination;